import * as types from './types'

export default {
  [types.MUTATE_LEAD]: (state, payload) => {
    state.leadData = checkoutData
  }
}
